/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum messageTypeEnum {
  ERROR = 'Error',
  CONFIGURATION_ERROR = 'ConfigurationError',
  INFORMATION = 'Information',
}
